import React, { useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import styles from './index.module.scss';

import { If } from 'utils';
import { Layout, Logo, ChangePassword } from 'components';
import { useAppContext, useSegmentPageCapture } from 'utils/hooks';
import { AuthContext } from 'context/AuthContext';
import { STORAGE_KEYS } from 'utils/DICTIONARY';

const QUERY_PARAMS = { auth_token_required: 'required' };

export default function ForceChangePassword() {
  useSegmentPageCapture('Force Password Change');

  const { search = '' } = useLocation();

  const [isSuccess, setSuccess] = useState(false);

  const { appName } = useAppContext();
  const { changeLocalStoreData = () => {} } = useContext(AuthContext);

  const onPasswordUpdated = () => {
    setSuccess(true);
    const storageKey = STORAGE_KEYS.PASSWORD_CHANGE_REQUIRED;
    changeLocalStoreData(storageKey, JSON.stringify(false));
    setTimeout(() => {
      const redirectTo = new URLSearchParams(search).get('redirectTo');
      window.location.href = redirectTo ? redirectTo : '/';
    }, 2000);
  };

  return (
    <>
      <Layout.Header>
        <Layout.Nav className="ml-auto">
          <Layout.Nav.User />
        </Layout.Nav>
      </Layout.Header>
      <div className={styles.container}>
        <Logo />
        <h4 className="mt-4">Please create a secure password to continue</h4>
        <p className="mb-4">
          Before you continue, please create a strong and secure password so
          that your {appName} account is protected. Please follow the
          requirements for the password.
        </p>
        <ChangePassword.Form
          queryParams={QUERY_PARAMS}
          onSuccess={onPasswordUpdated}
        />
        <If test={isSuccess}>
          <div className="mt-3 text-center">
            <strong className="text-success">
              Password changed successfully! You will be redirected shortly.
            </strong>
          </div>
        </If>
      </div>
      <ToastContainer className="app-toast-container" />
    </>
  );
}
